import { MultiSelect, MultiSelectOption } from 'components/forms/multiselect/MultiSelect';
import { MultiSelectPopup } from 'components/forms/multiselect/MultiSelectPopup';
import { InfiniteScroll } from 'components/infinite_scroll/InfiniteScroll';
import { useInfiniteBaseStationDataSource } from 'custom_hooks/data_hooks/data_source/baseStationDataSource';
import { useDebounceCallback } from 'custom_hooks/useDebounceCallback';
import { useMemo } from 'react';
import { getHardwareDisplay, getHardwareDisplayString } from 'utils/serialNumber';

export type BaseStationsMutliSelectProps = Readonly<{
    locationId: string;
    baseStationIds: MultiSelectOption<string>[];
    onChange: (baseStationIds: MultiSelectOption<string>[]) => void;
}>;

export function BaseStationsMutliSelect({
    locationId,
    baseStationIds,
    onChange,
}: BaseStationsMutliSelectProps) {
    const {
        results: baseStations,
        hasNext,
        isLoading,
        loadNext,
        filter,
        setFilter,
    } = useInfiniteBaseStationDataSource({
        name: 'multi-select-base-stations',
        defaultFilter: { locationId, nameSearch: '' },
    });

    const multiSelectBaseStations = useMemo(
        () =>
            baseStations?.map((b) => ({
                title: getHardwareDisplayString(b.SerialNumber, b.Name),
                value: b.Id.toString(),
                label: getHardwareDisplay(b.SerialNumber, b.Name),
            })) ?? [],
        [baseStations]
    );

    const filterDebounce = useDebounceCallback(250, (value) => {
        setFilter({
            ...filter,
            nameSearch: value,
        });
    });

    return (
        <>
            <MultiSelectPopup
                label="Base Station(s)"
                searchPlaceholder="Filter base stations"
                contentClassName="menu-max-height ml-10"
                popupClassName="modal-popup"
                searchable
                onFilterChange={filterDebounce}
            >
                <InfiniteScroll
                    enabled={hasNext ?? false}
                    isLoading={isLoading}
                    onLoadMore={loadNext}
                    className="f-14"
                    style={{ maxHeight: '30rem', minHeight: '5rem' }}
                >
                    <MultiSelect
                        options={multiSelectBaseStations}
                        selectedOptions={baseStationIds}
                        onChange={(event) => onChange(event.selected)}
                    />
                </InfiniteScroll>
            </MultiSelectPopup>
        </>
    );
}
